import {
  type LocationAutocompleteResult,
  isNotEmpty,
  type LocationAutocompleteInput,
  type LocationAutocompleteSuccess,
} from '@terros/common'
import { useTantalimQuery } from '../query'
import { autocompleteKey } from '../keys'
import { type GetHookResponse } from '../hooks'

export function useAutocomplete(input: LocationAutocompleteInput): GetHookResponse<LocationAutocompleteResult[]> {
  return useTantalimQuery<LocationAutocompleteInput, LocationAutocompleteSuccess, LocationAutocompleteResult[]>({
    url: '/location/autocomplete',
    queryKey: autocompleteKey(input.query, input.provider),
    input,
    convertResponse: (data) => {
      return data.results
    },
    options: {
      enabled: isNotEmpty(input.query),
    },
  })
}
